module.exports = __webpack_public_path__ + "assets/2eb49d572c39ef6fb6d94d74592f2872.png";